export default __webpack_public_path__ + "static/media/yumi_crop_resize.b45c5ad8.jpg";